import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'
import ShareBackButton from './ShareBackButton'
import ShareCopyLink from './ShareCopyLink'
import ShareFacebookLink from './ShareFacebookLink'
import ShareLinkedinLink from './ShareLinkedinLink'
import ShareTwitterLink from './ShareTwitterLink'


const ShareLinks = () => {
    const {uiStore: {hideShareCard}} = useStore()
    return (
        <div className='share-links flex--center'>
            <h5 className='text-xs'>Share: </h5>
            <div className='flex share-links-container'>
                <ShareFacebookLink/>
                <ShareTwitterLink/>
                <ShareLinkedinLink/>
                <ShareCopyLink/>
                <ShareBackButton/>
            </div>

            <style jsx>{`
                .share-links {
                    padding: 20px 0;
                }
                .share-links-container {
                    margin-left: 20px;
                    width: 275px;
                    align-items: center;
                    justify-content: space-between;
                }
            `}</style>
        </div>
    )
}


export default ShareLinks